export default __webpack_public_path__ + "1d2ae0f132d729228aba9e8af59011eb.png";